<template>
  <b-col cols="alto" class="sidebar">
    <router-link to="/dashboard">
      <img
        style="width: 10rem; padding-left: 1rem; padding-right: 1rem"
        alt="Vue logo"
        src="../assets/images/logo.png"
      />
      <p class="img-text">Aggregator Portal</p>
    </router-link>
    <ul class="sidebar-menu">
      <li v-for="nav in navs" :key="nav.url" class="mb-2" active-class="active">
        <router-link
          :to="nav.url"
          class="py-1 px-8 sideNav block text-sm"
          active-class="active"
        >
          <svg
            :width="nav.width"
            :height="nav.width"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              :d="nav.icon"
              fill="none"
              stroke="currentColor"
            />
          </svg>
          <span style="padding-top: 0.25rem; padding-left: 0.625rem">
            {{ nav.title }}</span
          >
        </router-link>
      </li>
      <button @click="logoutUser" class="absolute-bottom">Logout</button>
    </ul>
  </b-col>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Sidebar",
  components: {},
  data() {
    return {
      navs: [
        {
          url: "/dashboard",
          title: "Dashboard",
          width: "29",
          height: "29",
          icon:
            "M10.773 12.568H7.236c-1.421 0-2.573-1.151-2.573-2.573V6.458c0-1.421 1.151-2.573 2.573-2.573h3.538c1.421 0 2.573 1.151 2.573 2.573v3.538c0 1.421-1.151 2.573-2.573 2.573zm14.473 0h-3.538c-1.421 0-2.573-1.151-2.573-2.573V6.458c0-1.421 1.151-2.573 2.573-2.573h3.538c1.421 0 2.573 1.151 2.573 2.573v3.538c0 1.421-1.151 2.573-2.573 2.573zM10.773 27.04H7.236c-1.421 0-2.573-1.151-2.573-2.573V20.93c0-1.421 1.151-2.573 2.573-2.573h3.538c1.421 0 2.573 1.151 2.573 2.573v3.538c0 1.421-1.151 2.573-2.573 2.573zm14.473 0h-3.538c-1.421 0-2.573-1.151-2.573-2.573V20.93c0-1.421 1.151-2.573 2.573-2.573h3.538c1.421 0 2.573 1.151 2.573 2.573v3.538c0 1.421-1.151 2.573-2.573 2.573z",
        },
        {
          url: "/pinpad-transactions",
          title: "Pinpad Transactions",
          width: "28",
          height: "28",
          icon:
            "M22.256 3.231H7.897c-1.983 0-3.59 1.519-3.59 3.392v18.092c0 .624.536 1.131 1.197 1.131H24.65c.661 0 1.197-.507 1.197-1.131V6.623c0-1.874-1.607-3.392-3.59-3.392z M20.371 14.539H8.705a1.16 1.16 0 0 1-1.167-1.154v-5a1.16 1.16 0 0 1 1.167-1.154h11.667a1.16 1.16 0 0 1 1.167 1.154v5a1.16 1.16 0 0 1-1.167 1.154z M7.538 18h1.167m3.5 0h1.167m-5.834 3.462h1.167m3.5 0h1.167M16.871 18h4.667",
        },
        {
          url: "/pos-transactions",
          title: "POS Transactions",
          width: "28",
          height: "28",
          icon:
            "M20.33 24.061c-3.558 0-6.443-2.869-6.443-6.406s2.885-6.406 6.443-6.406 6.443 2.869 6.443 6.406-2.884 6.406-6.443 6.406M1 5.932h24.485 M13.887 17.655H3.577A2.57 2.57 0 0 1 1 15.093V3.562A2.57 2.57 0 0 1 3.577 1h19.33a2.57 2.57 0 0 1 2.577 2.562m.001 0v10.249m-5.812 1.205v2.588m0 0h2.603",
        },
        {
          url: "/bank-transfer",
          title: "Bank Transfer",
          width: "25",
          height: "25",
          icon:
            "M4 16V7.33 M20 7.33V16M12 2L2 8.67M12 2l10 6.67M8 10v4m4-4v4m4-4v4m-7 8l2-2m-2-2l2 2m0 0H3m18 0h-6",
        },
        {
          url: "/account-opening",
          title: "Account Opening",
          width: "26",
          height: "26",
          icon:
            "M21 7H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1z M9 11h6 M18.667 21H5.333a2 2 0 0 1-2-2V7h17.333v12a2 2 0 0 1-1.999 2z",
        },
        {
          url: "/top-agents",
          title: "Top Agents",
          width: "28",
          height: "28",
          icon:
            "M4.856 6.092a2.42 2.42 0 0 1 2.419-2.419H21.79a2.42 2.42 0 0 1 2.419 2.419m-.001 16.934a2.42 2.42 0 0 1-2.419 2.419H7.275a2.42 2.42 0 0 1-2.419-2.419 M24.208 6.092v2.564m0 4.452v9.918m-19.352 0v-2.238m0-4.778V6.092 M19.234 16.633l3.474-4.146m-16.405 4.36l3.625-4.36 M12.881 12.547l3.47 4.086 M4.848 17.224a1.2 1.2 0 1 1-.851 2.051 1.2 1.2 0 0 1 .85-2.051m0-1.814a2.99 2.99 0 0 0-2.132.883 3.02 3.02 0 0 0 0 4.266c.57.57 1.327.883 2.132.883s1.563-.313 2.132-.883a3.02 3.02 0 0 0 0-4.266c-.57-.57-1.327-.883-2.132-.883h0 0zm12.95 1.572a1.2 1.2 0 1 1-.851 2.051 1.2 1.2 0 0 1-.007-1.693 1.21 1.21 0 0 1 .858-.358m0-1.814a2.99 2.99 0 0 0-2.132.883c-1.182 1.191-1.174 3.101.005 4.271a2.99 2.99 0 0 0 2.128.878 2.99 2.99 0 0 0 2.132-.883 3.02 3.02 0 0 0 0-4.265c-.57-.57-1.327-.884-2.132-.884h0 0zm-6.424-5.447a1.2 1.2 0 1 1-.851 2.051 1.2 1.2 0 0 1 .85-2.051m0-1.814a2.99 2.99 0 0 0-2.132.883 3.02 3.02 0 0 0 0 4.265c.57.57 1.327.883 2.132.883s1.563-.313 2.132-.883a3.02 3.02 0 0 0 0-4.266 3 3 0 0 0-2.132-.882h0zm12.844 1.814a1.2 1.2 0 1 1-.851 2.051 1.2 1.2 0 0 1 .85-2.051m0-1.814a2.99 2.99 0 0 0-2.132.883 3.02 3.02 0 0 0 0 4.265c.57.57 1.327.883 2.132.883s1.563-.313 2.132-.883a3.02 3.02 0 0 0 0-4.266 3 3 0 0 0-2.132-.882h0z",
        },
        {
          url: "/agent-list",
          title: "Agent List",
          width: "28",
          height: "28",
          icon:
            "M11.588 9.862a2.6 2.6 0 0 1-3.677 3.677 2.6 2.6 0 0 1 3.677-3.677m11.539-1.179a3.29 3.29 0 1 1-4.653 4.653 3.29 3.29 0 1 1 4.653-4.653M26.65 23.4v-1.3a3.9 3.9 0 0 0-3.9-3.9h-3.9a3.9 3.9 0 0 0-3.9 3.9v1.3m-3.9-5.2h-2.6a3.9 3.9 0 0 0-3.9 3.9v1.3",
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      logout: "user/logout",
    }),
    logoutUser() {
      this.logout().then(
        window.localStorage.setItem("clickedLogout", "true"),
        this.$router.replace({ name: "Login" })
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  --tw-shadow: 0 1px 3px 0 hsla(0, 0%, 0%, 0.1),
    0 1px 2px 0 hsla(0, 0%, 0%, 0.06);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 hsla(0, 0%, 0%, 0)),
    var(--tw-ring-shadow, 0 0 hsla(0, 0%, 0%, 0)), var(--tw-shadow);
  background: hsl(0, 0%, 100%);
  padding: 1rem 0 !important;
}
.sidebar-menu {
  padding-top: 3.7rem;
}
ul {
  list-style: none;
}
li > a {
  display: flex;
  align-items: center;
  border-left: 3px solid transparent;
  padding: 1rem 1.18rem;
  width: 100%;
  font-size: 1rem;
  text-decoration: none;
  color: var(--gray-dark);
  margin-bottom: 1.5rem;
}
li > a:hover,
.active {
  color: var(--primary);
  border-left: 3px solid var(--primary);
  background: hsla(349, 85%, 56%, 0.05);
}
.absolute-bottom {
  position: absolute;
  bottom: 0;
  border: none;
  background: transparent;
  color: var(--primary);
  padding: 0.5rem 1rem;
  margin-left: 1rem;
}
.absolute-bottom:hover {
  background: hsla(349, 85%, 56%, 0.05);
}
.img-text {
  color: hsl(349, 85%, 56%);
  padding-left: 2rem;
  padding-right: 2rem;
}
</style>
